import { useState, useCallback } from 'react';

type ConfirmOptions = { open: boolean; title?: string; message?: string; confirmText?: string; cancelText?: string };

export function useConfirm() {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState<ConfirmOptions>();
  const [resolver, setResolver] = useState<(() => void) | null>(null);

  const confirm = useCallback((opts: ConfirmOptions) => {
    setOptions(opts);
    setOpen(true);
    return new Promise<boolean>(resolve => {
      setResolver(() => resolve);
    });
  }, []);

  const onCancel = useCallback(() => {
    setOpen(false);
    setResolver(null);
  }, []);

  const onConfirm = useCallback(() => {
    setOpen(false);
    if (resolver) resolver();
    setResolver(null);
  }, [resolver]);

  return {
    confirm,
    onCancel,
    onConfirm,
    open,
    title: options?.title,
    message: options?.message,
    confirmText: options?.confirmText,
    cancelText: options?.cancelText,
  };
}

export default useConfirm;
